import React from 'react';
import PropTypes from 'prop-types';

import './SidePanel.scss';

import SidePanelControls from './SidePanelControls.js';
import SidePanelItems from './SidePanelItems.js';

/**
 * Renders a full height sidebar with a specified items.
 */
class SidePanel extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="SidePanel">
        <SidePanelControls
          activeItemId={this.props.activeItemId}
          controls={this.props.items}
          setActiveitem={this.props.onChange}
        />
        <SidePanelItems
          activeItemId={this.props.activeItemId}
          opened={!!this.props.activeItemId}
          items={this.props.items}
          onClose={this.props.onClose}
        />
      </div>
    );
  }
}

const SidePanelItemShape = PropTypes.shape({
  /**
   * This is some string, used as an id of parent container for the item and to manage component state externally
   */
  id: PropTypes.string.isRequired,
  /**
   * Either icon id from SVGStore or some react element
   */
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /**
   * Which item belongs to which control group (all items must have it set)
   */
  group: PropTypes.string.isRequired,
  /**
   * Tooltip text for the item icon and header test as well.
   */
  label: PropTypes.string.isRequired,
  /**
   * Optional panel header extension node.
   */
  headerExtension: PropTypes.node,
  /**
   * Invoked on icon click with item id as an argument.
   */
  onClick: PropTypes.func,
  /**
   * If your item is a react component, just provide it as a item content
   */
  content: PropTypes.node,
  /**
   * By default, item container does not provide any sofisticated styling, so that you can do your own and pass it to this item
   */
  className: PropTypes.string,
  /**
   * Style object
   */
  style: PropTypes.object,
  /*
   * Whether item is disabled (greyed out) or not
   */
  disabled: PropTypes.bool
});

SidePanel.propTypes = {
  /**
   * Array of items to show
   */
  items: PropTypes.arrayOf(SidePanelItemShape).isRequired,
  /**
   * Invoked when changing active item
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Invoked when clicking on close icon
   */
  onClose: PropTypes.func.isRequired,
  /**
   * Currently active item id
   */
  activeItemId: PropTypes.string
};

export { SidePanel as default, SidePanelItemShape };
